import { render, staticRenderFns } from "./header-default.vue?vue&type=template&id=210954f2&"
import script from "./header-default.vue?vue&type=script&lang=ts&"
export * from "./header-default.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports